import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import TmsLayout from "@/components/TmsLayout";

import HomePage from "@/pages/public/HomePage";
import DevisPage from "@/pages/public/DevisPage";
import SuiviPage from "@/pages/public/SuiviPage";
import ServicesPage from "@/pages/public/ServicesPage";
import AboutPage from "@/pages/public/AboutPage";
import EngagementPage from "@/pages/public/EngagementPage";
import ActualitesPage from "@/pages/public/ActualitesPage";
import ContactPage from "@/pages/public/ContactPage";

import TmsLoginPage from "@/pages/tms/TmsLoginPage";
import TmsDashboard from "@/pages/tms/TmsDashboard";
import OtListPage from "@/pages/tms/OtListPage";
import OtDetailPage from "@/pages/tms/OtDetailPage";
import InvoicesPage from "@/pages/tms/InvoicesPage";
import CarriersPage from "@/pages/tms/CarriersPage";
import QuotesPage from "@/pages/tms/QuotesPage";

function App() {
    return (
        <AuthProvider>
            <LangProvider>
            <BrowserRouter>
                <Toaster theme="light" position="top-right" richColors />
                <Routes>
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/devis" element={<DevisPage />} />
                        <Route path="/suivi" element={<SuiviPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/a-propos" element={<AboutPage />} />
                        <Route path="/engagement" element={<EngagementPage />} />
                        <Route path="/actualites" element={<ActualitesPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                    </Route>

                    <Route path="/tms/login" element={<TmsLoginPage />} />

                    <Route
                        path="/tms"
                        element={
                            <ProtectedRoute>
                                <TmsLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<TmsDashboard />} />
                        <Route path="ot" element={<OtListPage />} />
                        <Route path="ot/:id" element={<OtDetailPage />} />
                        <Route path="invoices" element={<InvoicesPage />} />
                        <Route path="carriers" element={<CarriersPage />} />
                        <Route path="quotes" element={<QuotesPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            </LangProvider>
        </AuthProvider>
    );
}

export default App;
